import React, { useCallback } from "react";
import Drawer from "@mui/material/Drawer";
import { useTheme } from "@mui/material/styles";

export const defaultDrawerWidth = 540;
const minDrawerWidth = 50;
const minLeftWidth = 55;

export type PageLayoutProps = {
  children?: React.ReactElement | React.ReactElement[];
  contentTop: number;
  open?: boolean;
  onClose?: () => void;
}

export const InnerDrawer: React.FC<PageLayoutProps> = ({contentTop, children, open = true, onClose = () => {}}) => {
  const [drawerWidth, setDrawerWidth] = React.useState(defaultDrawerWidth);

  const theme = useTheme();
  const draggerColor = `${theme.palette.divider}`;

  const useStyles = {
    drawer: {
      flexShrink: 0
    },
    dragger: {
      width: "5px",
      height: "5000px",
      cursor: "ew-resize",
      padding: "4px 0 0",
      borderTop: "1px solid " + theme.palette.divider,
      top: 0,
      bottom: 0,
      zIndex: 100,
      backgroundColor: draggerColor,
      color: draggerColor
    }
  };

  const handleMouseDown = () => {
    document.addEventListener("mouseup", handleMouseUp, true);
    document.addEventListener("mousemove", handleMouseMove, true);
  };

  const handleMouseUp = () => {
    document.removeEventListener("mouseup", handleMouseUp, true);
    document.removeEventListener("mousemove", handleMouseMove, true);
  };

  const handleMouseMove = useCallback((e: any) => {
    const newWidth =
      document.body.offsetWidth - (e.clientX - document.body.offsetLeft);
    const maxDrawerWidth = document.body.offsetWidth - minLeftWidth;
    if (newWidth > minDrawerWidth && newWidth < maxDrawerWidth) {
      setDrawerWidth(newWidth);
    }
  }, []);

  return (
    <Drawer
      sx={useStyles.drawer}
      open={open}
      onClose={onClose}
      anchor={"right"}
      variant="persistent"
      PaperProps={{ style: { width: drawerWidth, top: contentTop, boxSizing: 'border-box'} }}
    >
      <div onMouseDown={() => handleMouseDown()} style={{...useStyles.dragger, position: "absolute"}} />
      <div style={{paddingLeft: "10px"}}>
        {children}
      </div>
    </Drawer>
  );
}
